var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoeShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448.02 448.02",
    style: {
      enableBackground: "new 0 0 448.02 448.02"
    },
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071CE"
    },
    d: "M200.126,161.091c-8.325-17.186-15.836-48.897-44.21-48.897c-28.373,0-48.4,23.367,4.174,67.595   L200.126,161.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F58"
    },
    d: "M437.361,295.545c0-35.48-28.762-64.242-64.242-64.242c-34.559,0-113.951-23.638-155.737-65.423   c-41.786-41.786-64.768,4.357-91.928,4.357c-27.161,0-50.142-20.985-85.661-20.985c-35.518,0-34.473,51.279-34.473,92.02   c0,40.741,0,54.273,0,54.273H437.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C6C8"
    },
    d: "M217.382,165.88c-41.786-41.786-64.768,4.357-91.928,4.357c-27.161,0-50.142-20.985-85.661-20.985   c-27.653,0-33.142,31.085-34.217,64.078c26.574,3.768,84.781,26.672,105.105,82.215h125.001   c-14.686-59.25,17.115-72.73,43.827-60.756c21.455,9.618,40.715-2.11,42.403-12.509   C286.039,211.824,244.052,192.549,217.382,165.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071CE"
    },
    d: "M165.745,233.867h-57c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h57    c4.142,0,7.5,3.358,7.5,7.5C173.245,230.509,169.887,233.867,165.745,233.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071CE"
    },
    d: "M181.01,256.711h-57c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h57    c4.142,0,7.5,3.358,7.5,7.5C188.51,253.353,185.152,256.711,181.01,256.711z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B3E3"
    },
    d: "M125.454,170.237c-27.161,0-50.142-20.985-85.661-20.985c-12.555,0-20.53,6.42-25.608,16.504   c30.033,5.918,64.411,35.633,108.864,33.708c24.479-1.06,57.639-33.992,93.814-34.09   C175.407,124.491,152.501,170.237,125.454,170.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M429.608,289.846h-35.8c-66.146,0-265.817-16.922-326.298-16.922H14.32   c-8.438,0-14.32,6.905-14.32,15.344v32.215c0,8.438,5.882,15.343,14.32,15.343h415.287c10.127,0,18.412-8.286,18.412-18.412v-9.156   C448.02,298.131,439.734,289.846,429.608,289.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0071CE"
    },
    d: "M382.12,289.704c-29.316-0.629-74.753-3.306-122.727-6.345c2.492,7.871,3.945,15.984,1.783,21.016   c-2.956,6.879-16.243,20.591-27.504,31.451H376.47C380.882,322.236,384.199,305.694,382.12,289.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00B3E3"
    },
    d: "M99.177,311.875H48.51c-4.142,0-7.5-3.358-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h50.667   c4.142,0,7.5,3.358,7.5,7.5C106.677,308.517,103.319,311.875,99.177,311.875z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00416A"
    },
    cx: 209.986,
    cy: 185.568,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00416A"
    },
    cx: 232.673,
    cy: 201.289,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00416A"
    },
    cx: 257.843,
    cy: 214.945,
    r: 7.501
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoeShop);
export default __webpack_public_path__ + "static/media/shoe-shop.26ad5c402d0d1e33b306bb4ef868655b.svg";
export { ForwardRef as ReactComponent };